import React from 'react'
import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import ChooseWeekButtons from '../../general/ChooseWeekButtons'
import Translation from '../../Translation/cont/Translation'
import WrapperPageSimple from "../../WrapperPage/present/WrapperPageSimple"
import * as Yup from 'yup';
import { ErrorMessage, Form, Formik } from 'formik';
import DatepickerContainer from '../../forms/fields/DatepickerContainer';
import { v4 as uuidv4 } from 'uuid';
import { PreviewButton } from './FlyerButtons'
import PrintWeekProgramFlyerDateItemContainer from '../cont/PrintWeekProgramFlyerDateItemContainer'
import dndItemTypes from '../../../constants/dndItemTypes'
import SortableWrapperContainer from '../../../containers/dnd/SortableWrapperContainer'
import { Link } from 'react-router-dom'

const PrintFlyerWeeks = ({
    features, 
    deleteAllDateItems, 
    weekProgramFlyerData=null, 
    reorderItems, 
    printToolSetCustomPeriodActive=null, 
    printToolAddDatePeriod=null, 
    activeWeek, 
    hasChanges, 
    weeks, 
    cinemaId,
    printType, 
    printID, 
    landscape, 
    closePagePath,
    printToolSetWeek, 
    printUpdateRequest, 
    customDatePeriod,
}) => {
    if(!features) {
        return ''
    }

    const validationSchema = Yup.object().shape({
        startDate: Yup.string().required(<Translation id="formik_field_required" />),
        endDate: Yup.string().required(<Translation id="formik_field_required" />)
    });

    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })

    return (
        <WrapperPageSimple pageTitleTransId={printConfig.routes[printType].transIdname} closePagePath={closePagePath}>
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                {(features.has_flyer && printType === 'flyer') || (printType === 'weekProgramFlyer' && features.has_week_program_flyer) ? (
                    <div>
                        {customDatePeriod && <p className='text-regular title-list'><Translation id="print_flyer_select_week_title">Feste Wochenauswahl (Donnerstag bis Mittwoch)</Translation></p>}
                        <h3 className="gap-20 title-list text-regular"><Translation id="print_flyer_select_week">Spielwoche auswählen</Translation></h3>

                        <ChooseWeekButtons
                            activeWeek={parseInt(activeWeek)}
                            weeks={weeks} 
                            path={`${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${currentPrintFormat.landscape}`}
                            pathAfterWeek='edit'
                            // pathAfterWeek={printType}
                            updateWeek={printToolSetWeek}
                            customPeriodActive={weekProgramFlyerData ? weekProgramFlyerData.customPeriodActive : false}
                            activeWeekIsLink={true}
                        />

                        {weekProgramFlyerData && customDatePeriod && <>
                            <div className='text-regular gap-20 title-list'><Translation id="print_flyer_custom_date_period">Eigenen Zeitraum definieren inkl. Gruppieren von einzelnen Tagen</Translation></div>
                            <div className='setting-wrapper title-list gap-35'>
                            <label>
                                <p className='gap-10'><Translation id="print_flyer_activate_custom_date_period">Eigenen Zeitraum aktivieren</Translation></p>
                                <input type="checkbox" checked={weekProgramFlyerData.customPeriodActive} id="active-title-top-text" className="checkbox tgl tgl-flat" onChange={() => {
                                    printToolSetCustomPeriodActive(!weekProgramFlyerData.customPeriodActive)
                                }}/>
                                <span className="tgl-btn text-regular"><Translation id="print_flyer_activate_customization">Aktiv</Translation></span>
                            </label>
                            {weekProgramFlyerData.customPeriodActive && <Formik
                                initialValues={{
                                    startDate:'',
                                    endDate:'',
                                    id: null
                                }}
                                validationSchema={validationSchema}
                                onSubmit={(values, actions) => {
                                    if(!values.id) {
                                        values.id = uuidv4()
                                    }
                                    printToolAddDatePeriod(values)
                                    actions.resetForm()
                                }}
                            >
                            {({values, errors, touched, isSubmitting, handleReset, setFieldValue}) => 
                                <Form>
                                    <div className="datepicker-container add-custom-period gap-20">
                                        <div className="datepicker-wrapper">
                                            <DatepickerContainer
                                                name={"startDate"} 
                                                onChange={setFieldValue}
                                                value={values.startDate}
                                                resetValue={'endDate'}
                                                isStartDate={true}
                                                type="text" 
                                                id="startDate" 
                                                end={values.endDate}
                                            />
                                            <ErrorMessage className="text-regular-color" name="startDate" component="div" />  
                                        </div>
                                        <div className="datepicker-wrapper">
                                            <DatepickerContainer
                                                name={"endDate"} 
                                                onChange={setFieldValue}
                                                value={values.endDate}
                                                start={values.startDate}
                                                type="text" 
                                                id="endDate"
                                            />
                                            <ErrorMessage className="text-regular-color" name="endDate" component="div" />  
                                        </div>
                                    </div>
                                    <button type="submit" className='button button-text gap-30'><Translation id="print_flyer_add_custom_date_period">Zeitraum hinzufügen</Translation></button>
                                    <button type="button" onClick={() => {deleteAllDateItems()}} className='reset-period button button-text gap-30'><Translation id="print_flyer_reset_custom_date_period_completely">Zeitraum reseten</Translation></button>
                                </Form>
                            }
                            </Formik>}

                            {weekProgramFlyerData.customPeriodActive && weekProgramFlyerData.dateSettings && <div className='gap-30'>
                                {weekProgramFlyerData.dateSettings.order.length > 0 && weekProgramFlyerData.dateSettings.order.map((periodId, index) => {
                                    const {items} = weekProgramFlyerData.dateSettings
                                    const currentPeriodItem = items[periodId]
                            
                                    return (
                                        <SortableWrapperContainer
                                            index={index} 
                                            key={index}
                                            moveItem={reorderItems} 
                                            dndType={dndItemTypes.WEEK_PROGRAM_FLYER_DATE_ITEM}
                                        >
                                            <PrintWeekProgramFlyerDateItemContainer
                                                currentPeriodItem={currentPeriodItem}
                                            />
                                        </SortableWrapperContainer>
                                    )

                                })}
                            </div>}

                           {weekProgramFlyerData.customPeriodActive && <Link className={"button-wrapper button"} to={`${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${currentPrintFormat.landscape}/custom/edit`}>
                                {hasChanges ? (
                                    <button onClick={() => {printUpdateRequest()}} className={"button button-text"}><Translation id="print_flyer_use_custom_date_period"/></button>
                                ) : (
                                    <div className={"button-text"}><Translation id="print_flyer_use_custom_date_period"/></div>
                                )}
                            </Link> }
                            <div className="save-program-button save-button-wrapper">
                                <PreviewButton
                                    hasChanges={hasChanges}
                                    printType={printType}
                                    cinemaId={cinemaId}
                                    printID={printID}
                                    landscapeBoolean={landscapeBoolean}
                                    printUpdateRequest={printUpdateRequest}
                                    activeWeek={activeWeek}
                                />
                            </div>
                        </div>
                        </>}
                    </div>

                ) : (
                    <div><Translation id="print_week_feature_not_activated"/> <a className="support-mail text-regular-color cursor-pointer" href="mailto:info@pmkino.com">Support</a>.</div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default PrintFlyerWeeks